export const getInitials = (name: string, maxChars = 3) =>
  (name || '')
    .split(' ')
    .concat([''])
    .map((x) => x[0])
    .slice(0, maxChars)
    .join('')
